import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';
import { useAuth } from '../../contexts/AuthContext';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, signOut } = useAuth();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
    document.documentElement?.classList?.toggle('dark');
  };

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/signin');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const isSettingsActive = location?.pathname === '/settings';

  return (
    <header className="header-nav">
      <div className="header-nav-container">
        <Link to="/main-dashboard" className="header-logo">
          <div className="header-logo-icon">
            <Icon name="Grid3x3" size={24} color="var(--color-primary)" />
          </div>
          <span className="header-logo-text">EisenhowerMatrix</span>
        </Link>

        <div className="header-nav-actions">
          <button
            onClick={toggleDarkMode}
            className="header-nav-button"
            aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
            title={isDarkMode ? 'Light mode' : 'Dark mode'}
          >
            <Icon 
              name={isDarkMode ? 'Sun' : 'Moon'} 
              size={20} 
              color="currentColor" 
            />
          </button>

          <Link
            to="/onboarding-interactive-tour"
            className="header-nav-button"
            aria-label="Tutorial"
            title="Interactive Tour"
          >
            <Icon 
              name="Sparkles" 
              size={20} 
              color="currentColor" 
            />
          </Link>

          <Link
            to="/settings"
            className={`header-nav-button ${isSettingsActive ? 'bg-muted text-foreground' : ''}`}
            aria-label="Settings"
            title="Settings"
          >
            <Icon 
              name="Settings" 
              size={20} 
              color="currentColor" 
            />
          </Link>

          {user && (
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="header-nav-button"
                aria-label="User menu"
                title="User menu"
              >
                <Icon name="User" size={20} color="currentColor" />
              </button>

              {showUserMenu && (
                <div className="absolute right-0 mt-2 w-48 bg-card rounded-lg shadow-soft-lg border border-border py-1 z-50">
                  <div className="px-4 py-2 border-b border-border">
                    <p className="text-sm font-medium text-foreground truncate">{user?.email}</p>
                  </div>
                  <button
                    onClick={handleSignOut}
                    className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted flex items-center gap-2"
                  >
                    <Icon name="LogOut" size={16} color="currentColor" />
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;